import component from './component'

export default {
    path: '/resetpassword',
    name: 'resetpassword',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/account/resetPassword/index.js